import React from 'react';
import PropTypes from 'prop-types';

// The glyph is painted as a CSS mask, so its colour comes from `backgroundColor`, not the SVG fill.
// A `tone` selects an explicit paint; omitting it inherits the surrounding text colour as before.
const ICON_TONES = {
  black: '#000000',
};

const Icon = ({ src, size = 16, width, height, tone }) => {
  // `size` is the square fallback; a non-square glyph (e.g. the 12×19 bookmark) passes explicit
  // width/height so the box matches the design instead of letterboxing inside a square.
  const resolvedWidth = width ?? size;
  const resolvedHeight = height ?? size;
  return (
      <span
          style={{
        display: 'inline-block',
        width: resolvedWidth,
        height: resolvedHeight,
        verticalAlign: 'middle',
        WebkitMaskImage: `url(${src})`,
        maskImage: `url(${src})`,
        WebkitMaskRepeat: 'no-repeat',
        maskRepeat: 'no-repeat',
        WebkitMaskSize: 'contain',
        maskSize: 'contain',
        backgroundColor: ICON_TONES[tone] ?? 'currentColor',
      }}
      />
  );
};

Icon.propTypes = {
  src: PropTypes.string.isRequired,
  size: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
  tone: PropTypes.oneOf(['black']),
};

Icon.defaultProps = {
  size: 16,
  width: null,
  height: null,
  tone: null,
};

export default Icon;
